import { registerComparitor } from "routes/schedule/compare/register-comparitor"
import { RemovedGuidance } from "routes/schedule/compare/removed-guidance"
import { NewGuidance } from "routes/schedule/compare/new-guidance"
import { HeaderBar } from "routes/schedule/compare/header-bar"
import { attributeMap } from "routes/schedule/compare/register-task-comparitor"

registerComparitor("guidance", ({ compare, to, differences }) => {
    const compareGuidance = new Set(compare.legislation.map((c) => c.toString()))
    const toGuidance = new Set(to.legislation.map((c) => c.toString()))
    for (const guidance of compareGuidance) {
        if (!toGuidance.has(guidance)) {
            const header = (
                <HeaderBar label="References">
                    <NewGuidance guidance={guidance} componentType="NewGuidance" />
                </HeaderBar>
            )
            attributeMap.set(header, { name: `a${guidance}`, to, compare })
            differences.push(header)
        } else {
            toGuidance.delete(guidance)
        }
    }
    for (const guidance of toGuidance) {
        const header = (
            <HeaderBar label="References">
                <RemovedGuidance guidance={guidance} componentType={"RemovedGuidance"} />
            </HeaderBar>
        )
        attributeMap.set(header, { name: `r${guidance}`, to, compare })
        differences.push(header)
    }
})
